
import { Chip, ChipProps } from '@mui/material'
import React from 'react'

const ChipWrapper: React.FC<ChipProps> = ({ ...props }) => <Chip {...props} />

export default ChipWrapper
